export default __webpack_public_path__ + "static/media/termo-de-declaracao-de-responsabilidade.dbc631d5.pdf";